import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import AuthService from '../AuthService';
import Logo from '../images/Formstack_Sign_Product_Logo_Mono_Rev.svg';

const styles = theme => ({
  root: {
    width: '100%',
    fontFamily: theme.typography.fontFamily
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  img: {
    height: '1.5em'
  },
  loginButton: {
    float: 'right'
  },
  appHeader: {
    paddingRight: '15px',
    marginTop: '8px'
  },
  appBar: {
    backgroundColor: '#1C2F3A',
    height: '78px'
  }
});

function Header(props) {
  const { classes } = props;
  const Auth = new AuthService();
  const location = props.location.pathname;
  const renderHeader =
    Auth.userAuthenticated() &&
    (location === '/documents' || location === '/keypad');

  return renderHeader ? (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        color="primary"
        classes={{ colorPrimary: classes.appBar }}
        className={classes.appBar}
      >
        <Toolbar className={classes.appHeader}>
          <img alt="Logo" src={Logo} className={classes.img} />
          <Typography
            variant="title"
            align="right"
            color="inherit"
            className={classes.flex}
          >
            <Button
              color="inherit"
              className={classes.loginButton}
              onClick={() => {
                Auth.deauthenticateUser();
              }}
            >
              Sign out
            </Button>
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  ) : null;
}

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js